import React, { Component, forwardRef, useEffect, useImperativeHandle, useReducer, useRef, useState } from "react"
import useMeasure from "react-use-measure";
import { useSpring, animated, easings } from '@react-spring/web';

/**
 * 初始化state需调用initState，不要直接给this.state赋值
 */
export default class BaseView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            views: []
        }
        this.addView = this.addView.bind(this);
        this.clearView = this.clearView.bind(this);
        this.handleBack = this.handleBack.bind(this);
    }

    initState(states) {
        // for (const key in states) {
        //     this.state[key] = states[key];
        // }
        this.state = { ...this.state, ...states }
    }

    handleBack(w, state) {
        //if (this.state.views.length > 0) {
        window.history.pushState(null, null, document.URL);
        //}
    }

    componentDidMount() {
        if (window.history && window.history.pushState) {
            window.history.pushState(null, null, document.URL);
            window.addEventListener('popstate', this.handleBack, false)
        }
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handleBack, false);
    }

    /**
     * 
     * @param {HookFunction} view 要显示的View，必须是一个Hook Function
     * @param {string "left" or "right"} popFrom view弹出的位置，左侧弹出或右侧弹出 
     * @param {function} onViewClosed view关闭后回调
     * @param {function} onViewAction view action回调
     * @param {} params 传入view的其他参数
     * 
     * 经过addView处理后
     * ① view函数自带fireViewAction方法，可以在view的hook函数中调用props.fireViewAction，来触发onViewAction回调
     * action格式 {name:"actionName", value:"actionValue"}
     * actionName中，close为关闭view的action，会被拦截，并关闭当前view，不会发送给onViewAction回调
     * onViewAction接收到的action中，带有一个closeView函数，供主动关闭窗口使用
     * 
     * ② 如果view函数包含view.onViewEvent(event)函数，则会在窗口弹出或关闭时，调用此函数
     * event格式 {name:event_name} 包含 opening opened closing closed
     */
    addView(view, popFrom, onViewClosed, onViewAction, params) {
        const wrapper = <WrapperView key={this.state.views.length + 1}
            dirFrom={popFrom} View={view}
            onClosed={() => {
                this.#viewClosed(view)
                if (onViewClosed != null) onViewClosed();
            }} onViewAction={onViewAction} clearView={this.clearView} {...params} />
        this.setState({ views: [...this.state.views, wrapper] })
    }
    /**
     * 清除所有的view
     */
    clearView() {
        this.setState({ views: [] })
    }

    #viewClosed(view) {
        for (const key in this.state.views) {
            if (this.state.views[key].props.View == view) {
                this.state.views.splice(key, 1);
                break;
            }
        }
        this.setState({ views: [...this.state.views] });
    }
}

function WrapperView({ View, onClosed, dirFrom, onViewAction, ...props }) {

    const [close, setClose] = useState(false);
    const [ref, { width }] = useMeasure();

    const bgStyles = useSpring({
        from: { backgroundColor: close ? '#00000080' : '#00000000' },
        to: { backgroundColor: close ? '#00000000' : '#00000080' },
    })

    const aniFrom = dirFrom.toLowerCase() == "left" ? { x: close ? width : 0 } : { x: close ? -width : 0 }
    const aniTo = dirFrom.toLowerCase() == "left" ? { x: close ? 0 : width } : { x: close ? 0 : -width }

    const viewStyles = useSpring({
        from: aniFrom,
        to: aniTo,
        onStart: {
            x: () => {
                if (close) {
                    if (View.onViewEvent != null) {
                        View.onViewEvent({ name: "closing" })
                    }
                } else {
                    if (View.onViewEvent != null) {
                        View.onViewEvent({ name: "opening" })
                    }
                }
            }
        },
        onRest: {
            x: () => {
                if (close) {
                    onClosed();
                    if (View.onViewEvent != null) {
                        View.onViewEvent({ name: "closed" })
                    }
                } else {
                    if (View.onViewEvent != null) {
                        View.onViewEvent({ name: "opened" })
                    }
                }
            }
        }
    })

    const closeView = () => {
        setClose(true);
    }

    const fireViewAction = action => {
        if (action.name == "close") {
            //关闭当前view
            closeView();
            return;
        }
        if (!close && onViewAction != null) {
            action.closeView = closeView;
            onViewAction(action)
        }
    }

    const x = dirFrom.toLowerCase() == "left" ? -width : width;
    const aniClassName = "relative w-full h-full ";

    return <animated.div id="viewContainer" className={"absolute viewContainer w-full h-full left-0 top-0" + (width == 0 ? " opacity-0" : "")} style={{ ...bgStyles }}>
        <animated.div ref={ref} className={aniClassName}
            style={{ ...viewStyles, left: x + "px" }}>
            <View fireViewAction={fireViewAction} {...props} />
        </animated.div>
    </animated.div >
}
